<template>
    <div class="card-header py-2 px-3 d-flex align-items-center" :class="customClass">

        <h5 class="m-0 font-weight-bold text-primary fs-20 fw-700">
            {{ title }}
        </h5>

        <slot name="actions" />
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
          customClass: {
            type: [String, Array, Object],
            default: ''
        }
    }
};
</script>
